import React from 'react'
import { Navigate } from 'react-router-dom'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { useAuthorization } from '../generic/hooks/useAuthorization'
import OtherTask from '../configuration/othertask/OtherTask'

const MainOtherTask = () => {
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()

  // D7/S2: the backend gates the CRUD by OTHER_TASK; the screen must match. PICKLIST alone
  // only grants the Picklist section, whose card is already disabled without OTHER_TASK.
  if (!isUserAuthorized('OTHER_TASK')) {
    return <Navigate to='/configuration/picklist' replace />
  }

  const componentsInfo = [
    {
      title: t_('Other tasks'),
      component: <OtherTask />
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} />
}
export default MainOtherTask
